import { TRACK_CART_VIEWED } from '../types';
export const trackCartViewed = (options) => {
    return {
        type: TRACK_CART_VIEWED,
        payload: options,
    };
};
